<template>
  <div class="footerCol">
    <p class="footerCol__title" @click.prevent.stop="toggleMobileMenu()">
      <span>{{ title }}</span>
      <gl-svg-icon
        :icon="isShow ? 'action-minus' : 'action-plus'"
        class="footerCol__iconMenu"
      />
    </p>
    <transition name="slide" @enter="enter" @leave="leave">
      <slot v-if="isShow || $root.breakpoint.name !== 'phone'" />
    </transition>
  </div>
</template>

<script>
import { enter, leave } from "@/mixins";
import GlSvgIcon from "@gl/GlSvgIcon";

export default {
  components: { GlSvgIcon },
  mixins: [enter, leave],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      if (this.$root.breakpoint.name === "phone") {
        this.isShow = !this.isShow;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footerCol {
  $this: &;

  &__title {
    @include text-subtitle-1;

    color: #fff;
    align-items: center;
    cursor: pointer;
    display: flex;

    @media (min-width: $breakpoint-md) {
      cursor: default;
    }

    @media (min-width: $breakpoint-md) {
      margin-bottom: 32px;
    }
  }

  &__iconMenu {
    filter: invert(1);
    margin-left: auto;
    margin-right: 0;

    @media (min-width: $breakpoint-md) {
      display: none;
    }
  }
}
</style>
